import split from 'lodash/split';
import map from 'lodash/map';
import { getProductCardFields } from 'grandus-lib/utils';
import mapValues from 'lodash/mapValues';
import isString from 'lodash/isString';
import replace from 'lodash/replace';
import isArray from 'lodash/isArray';

export const getProcessedCardFields = (prefix = '') => {
  return map(split(getProductCardFields(), ','), field => `${prefix}${field}`);
};

export const createQueryString = (name, value, searchParams, remove) => {
  const params = new URLSearchParams(searchParams);
  params.set(name, value);
  if (remove) {
    params.delete(remove);
  }

  return decodeURIComponent(params.toString());
};

export const replaceDashesInObject = obj => {
  return mapValues(obj, value => {
    if (isString(value)) {
      return replace(value, /_/g, ' ');
    } else if (isArray(value)) {
      return map(value, item =>
        isString(item) ? replace(item, /_/g, ' ') : item,
      );
    }
    return value;
  });
};

export const scrollToId = (elementId) => {
  const element = document.getElementById(elementId);
  const headerOffset = 100;
  const elementPosition = element.getBoundingClientRect().top;
  const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

  window.scrollTo({
    top: offsetPosition,
    behavior: "smooth"
  });
}
